import React, { useState, useEffect } from 'react'
import { BrowserUtils, StorageUtils } from '../utils/siteUtils'
import usePlateFetcher from './usePlateFetcher'
import useVinFetcher from './useVinFetcher'
import { VehiclePageNumber } from '../constants'
import { AutoCheckErrorMessage } from '../utils/messagesUtils'
import { checkIneligibleYear } from '../utils/vehicleUtils'

export default landingContext => {
  const { urlState, updateGlobalState, globalState, offer } = landingContext
  const { vinNo, plateStateLookupVin, isIneligibleYear, submitVinCount = 0 } = globalState
  const [vinError, setVinError] = useState(false)
  const [ymmError, setYmmError] = useState(false)
  const { plateStateError, setPlateStateError, setPlateState, submitPlateStateCount, setSubmitPlateStateCount } = usePlateFetcher(landingContext, updateGlobalState, plateStateLookupVin)
  const vin = vinNo || plateStateLookupVin || urlState.vin || (offer && offer.prospect.vehicle.vin)
  const hasIneligibleYear = Boolean(vin && landingContext?.yearParam) && checkIneligibleYear(landingContext.yearParam)
  const isIneligibleYearUnassigned = vin && (hasIneligibleYear || isIneligibleYear) && !landingContext?.experienceState?.isAssigned
  const plateStateVinError = plateStateError || vinError || ymmError || isIneligibleYearUnassigned

  const offerUsedCads = offer && offer.prospect.vehicle.vehicleBuildDataFlags && offer.prospect.vehicle.vehicleBuildDataFlags.cadsUsed
  const offerHasVin = offer && offer.prospect.vehicle.vin
  const isNotConsumerResubmitOffer = urlState && urlState.p !== 13 && urlState.pa && urlState.pa.includes('reviewoffer')
  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////CADS LOGIC//////
  const newOfferBypassFlag = !offer // new offers: if true, then use cads
  const resubmitBypassFlag = offer && offer.isExpired && isNotConsumerResubmitOffer // if offer resubmit, but not in conumer. use cads
  const edgeCaseBypassFlags = !offerHasVin || !offerUsedCads // if offer is edited and is cads keep cads, if offer is resubmit and has vin use cads
  // this is the old bypass logic: (revert to original logic 6-18-2021)
  const cadsBypassFlag = newOfferBypassFlag ? false : resubmitBypassFlag ? false : edgeCaseBypassFlags ? true : false
  // this is the new to keep it off for the time being:
  //const cadsBypassFlag = !offerUsedCads ? true : false
  const vinVerifiedFlag = true
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const selectedTrim = urlState.s || (offer && offer.prospect.vehicle.trimId)
  const cancelRequest = landingContext && offer && offer && !offer.quickQuote && !offer.isExpired && offer.status.toLowerCase() === 'fr'
  const fromAuction = offer && !offer.isExpired && offer.status.toLowerCase() == 'auction'
  const { vinResults, vinNoError, vinIsFetching, vehicleIntoAuction, autoCheckData, cadsFlags, vinActiveDealer, vinActiveDealerIsFetching, vehicleTypical } = useVinFetcher(
    landingContext,
    vin,
    selectedTrim,
    submitVinCount,
    !!plateStateLookupVin,
    updateGlobalState,
    cadsBypassFlag,
    vinVerifiedFlag,
    fromAuction,
    cancelRequest
  )
  const isVinActiveDealer = vinActiveDealer && vinActiveDealer.totalResultCount && vinActiveDealer.totalResultCount > 0 && !vinActiveDealer.privateSeller && !landingContext.experienceState.isAdmin
  useEffect(() => {
    vin && setVinError(!!vinNoError)
  }, [vin, vinResults, vinNoError, submitPlateStateCount])

  useEffect(() => {
    if (vinIsFetching !== true && vinActiveDealerIsFetching !== true) {
      if (plateStateVinError === true || vehicleIntoAuction === true) {
        updateGlobalState({ fireAnalytics: 'continue_timbuybkhome_selltrade' })
      }
    }
  }, [plateStateVinError, vinIsFetching, updateGlobalState, vehicleIntoAuction, vinActiveDealerIsFetching])
  landingContext.plateStateVinError = plateStateVinError || vehicleIntoAuction || !!isVinActiveDealer
  landingContext.vehicleIntoAuction = vehicleIntoAuction
  landingContext.autoCheckData = autoCheckData
  landingContext.vehicleTypical = vehicleTypical
  landingContext.ymmError = ymmError
  landingContext.isVinError = vinNoError
  landingContext.vinActiveDealer = vinActiveDealer
  landingContext.experienceState.vehicleIntoAuction = vehicleIntoAuction

  if (vehicleIntoAuction || isIneligibleYearUnassigned) {
    if (!landingContext.experienceState.isAdmin && (landingContext.experienceState.isDigitalRetail || landingContext.experienceState.isCobrandDR)) {
      if (['WC', 'TC', 'OC', 'D'].includes(landingContext.experienceState.offerCode.toUpperCase())) {
        landingContext.isErrorNeedUseTradeInValue = true
        landingContext.plateStateVinErrorMessage = undefined
      } else {
        landingContext.isErrorNeedUseTradeInValue = false
        landingContext.plateStateVinErrorMessage = <AutoCheckErrorMessage vin={vin} />
      }
    } else {
      landingContext.isErrorNeedUseTradeInValue = false
      landingContext.plateStateVinErrorMessage = <AutoCheckErrorMessage vin={vin} />
    }
  }

  landingContext.vinResults = vinResults
  landingContext.vinIsFetching = vinIsFetching
  landingContext.cadsFlags = cadsFlags
  setContextMethods({ landingContext, updateGlobalState, setPlateState, setPlateStateError, setVinError, setYmmError, setSubmitPlateStateCount, submitPlateStateCount, submitVinCount })
}

const setContextMethods = ({ landingContext, updateGlobalState, setPlateState, setPlateStateError, setVinError, setYmmError, setSubmitPlateStateCount, submitPlateStateCount, submitVinCount }) => {
  //resetType 1 plate, 2 vin, 0 ymm, improve enum later, 0 ymm change already clears vin in url
  const resetPage = resetType => {
    setPlateStateError()
    setVinError()
    setYmmError()
    if (resetType) {
      //clears infor to allow user to select YMM changes
      setPlateState()
      //This is Critical to allowing the vin to be cleared if the user enters a different plate/vin/ymm
      //lp: This is Critical to allowing the vin to be cleared if the user enters a different plate/vin/ymm
      updateGlobalState({ vinNo: undefined, plateStateLookupVin: undefined, lp: undefined })
    }
    if (resetType === 2) updateGlobalState({ plate: undefined, state: undefined })
  }
  const presumitPage = (isVinForm, notFromLanding) => {
    updateGlobalState({ fromLanding: !notFromLanding, plateStateLookupVin: undefined, backToVin: false, ...(!isVinForm ? { vinNo: undefined } : {}) })
    setPlateState()
    StorageUtils.clearProspect()
  }

  landingContext.resetPlateStateVinForm = resetPage
  landingContext.submitPlateStateForm = plateState => {
    if (plateState.plate && plateState.state) {
      presumitPage()
      setSubmitPlateStateCount(submitPlateStateCount + 1)
      setPlateState(plateState)
    } else setPlateStateError(true)
  }
  landingContext.submitVinNoForm = (vinNo, notFromLanding) => {
    if (vinNo) {
      presumitPage(true, notFromLanding)
      updateGlobalState({ vinNo, submitVinCount: submitVinCount + 1 })
    } else setVinError(true)
  }
  landingContext.submitYMMForm = () => {
    const { year, make, model, trims, urlState, mileage } = landingContext
    const hasTrim = urlState.s || (trims && trims.length === 1)
    if (year && make && model && hasTrim && mileage) {
      presumitPage()
      setYmmError(false)
      updateGlobalState({ isIneligibleYear: false, fireAnalytics: 'continue_timbuybkhome_selltrade_mm' })
      const onlyTrim = !urlState.s && trims[0]
      const updateState = onlyTrim ? { s: onlyTrim.trimId } : {}
      const ymmObject = { year, make, model, updateState }
      const stateObject = onlyTrim ? { scroll: 1, trim: onlyTrim } : { scroll: 1 }
      BrowserUtils.navigateWithUrlState({ ...ymmObject, urlState, updateState: { p: VehiclePageNumber, lp: VehiclePageNumber } }, stateObject)
    } else setYmmError(true)
  }
}
